import { forwardRef } from "react";
import type { Ref } from "react";
import { Slot } from "@radix-ui/react-slot";
import { Spinner } from "../Spinner";
import { Root } from "./style";
import type { ButtonProps } from "./types";

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  {
    variant = "primary",
    size = "md",
    loading = false,
    disabled,
    icon,
    iconPosition = "left",
    asChild = false,
    children,
    ...rest
  },
  ref,
) {
  const inner = loading ? (
    <>
      <Spinner size="sm" aria-label="Carregando" />
      {children}
    </>
  ) : (
    <>
      {icon && iconPosition === "left" ? icon : null}
      {children}
      {icon && iconPosition === "right" ? icon : null}
    </>
  );

  if (asChild) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const SlotRoot = Root as any;
    return (
      <SlotRoot
        as={Slot}
        ref={ref as Ref<HTMLButtonElement>}
        $variant={variant}
        $size={size}
        {...rest}
      >
        {inner}
      </SlotRoot>
    );
  }

  return (
    <Root
      ref={ref}
      $variant={variant}
      $size={size}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {inner}
    </Root>
  );
});

// Compat: manter default export — Button atual usa default export.
export default Button;

export type { ButtonProps, ButtonVariant, ButtonSize } from "./types";
